import React from "react";
import Input from "./input";

const Entry = ({ dialectic, handleChange, handleKeypress, item }) => (
  <Input
    name={item}
    id={item}
    placehoder={item}
    value={dialectic[item]}
    onChange={handleChange}
    onKeyDown={handleKeypress}
    autoFocus
  />
);

export default Entry;
